import React from 'react'
// components
import { Modal } from 'components/UI'
// view components
import AddLinkForm from 'components/Modals/AddLinkModal/Form'
// constants
import { Modals } from 'constants/index'
// hooks
import { useModalData } from 'hooks/index'
// utils
import { handleError } from 'utils/errors/handlers'

const PAPER_PROPS = {
  style: {
    margin: 0,
    overflow: 'auto',
    position: 'fixed' as any,
    width: 400
  }
}

const AddLinkModal: React.FC = () => {
  const {
    hideModal,
    modalData: { width, isOpen, handleConfirm }
  } = useModalData({ modalType: Modals.ADD_LINK_FOR_ACTIVITY_MODAL })

  const handleFormSubmit = async (data) => {
    try {
      await handleConfirm(data)
      hideModal()
    } catch (errors) {
      handleError(errors, 'AddLinkModal.handleFormSubmit')
    }
  }

  return (
    <Modal
      hideBackdrop
      width={width}
      isOpen={isOpen}
      disableBackdropClick
      disableEscapeKeyDown
      PaperProps={PAPER_PROPS}>
      <AddLinkForm hideModal={hideModal} onSubmit={handleFormSubmit} />
    </Modal>
  )
}

export default AddLinkModal
